module["exports"] = [
  "gmail.com",
  "yahoo.com",
  "hotmail.com"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/nl/internet/free_email.js
 ** module id = 811
 ** module chunks = 0
 **/